//
import Model from '@/models/Model'
import Activate from '@/models/Activate'

//
export default class extends Model {
    /**
     *
     */
    static includes = ['hr_contract_type', 'hr_employee']

    /**
     *
     */
    get hr_contract_type_name() {
        return this.hr_contract_type ? this.hr_contract_type.name : '-'
    }

    /**
     *
     */
    get hr_employee_full_name() {
        return [
            this.hr_employee.names,
            this.hr_employee.last_name1,
            this.hr_employee.last_name2,
        ].join(' ')
    }

    /**
     *
     */
    activate() {
        return this.hasMany(Activate)
    }

    /**
     *
     */
    mapDetail = item => {
        //
        return {
            amount: item.amount,
            hr_asset_discount_id: item.hr_asset_discount_id || item.id,
            periodic: item.periodic,
            periodic_month: Number(
                String(item.new_periodic_month)
                    .split('-')
                    .pop()
            ),
        }
    }

    /**
     *
     */
    mapSelected = item => {
        //
        return {
            ...item,
            name: item.hr_asset_discount.name,
        }
    }

    /**
     *
     */
    reset() {
        //
        this.end_date = this.end_date || undefined
        this.selected = this.hr_contract_asset_discount.map(this.mapSelected)
        //
        return this
    }

    /**
     *
     */
    resource() {
        return 'hr_contract'
    }

    /**
     *
     */
    toCreate() {
        //
        this.hr_contract_asset_discount = this.selected.map(this.mapDetail)

        //
        return this.clean([
            'hr_employee_id',
            'hr_contract_asset_discount',
            'hr_contract_period_id',
            'hr_contract_type_id',
            'weekly_hours',
            'base_salary',
            'collation',
            'mobilization',
            'init_date',
            'end_date',
            'vacations_since',
            'vacations_progressive_days',
        ])
    }

    /**
     *
     */
    toUpdate() {
        //
        this.contract_asset_discount = this.selected.map(this.mapDetail)

        //
        return this.clean([
            'hr_employee_id',
            'contract_asset_discount',
            'hr_contract_period_id',
            'hr_contract_type_id',
            'id',
            'weekly_hours',
            'base_salary',
            'collation',
            'mobilization',
            'init_date',
            'end_date',
            'vacations_since',
            'vacations_progressive_days',
        ])
    }
}
